import React from "react";

export default function STDEV_P() {
  return <div>Excel_STDEV_P</div>;
}
